import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { routes } from '../lib/routes';
import { useAuth } from '../contexts/AuthContext';
import { Spinner } from '../components/common';

interface PrivateLayoutProps {
  children?: React.ReactNode;
}

const PrivateLayout = ({ children }: PrivateLayoutProps) => {
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className='min-h-screen bg-white flex items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (!isAuthenticated && !isLoading) {
    return <Navigate to={routes.login} replace />;
  }

  return <>{children || <Outlet />}</>;
};

export default PrivateLayout;
